import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventBookingListPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Bookings</EventSubPageTitle>;
};
